import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Breadcrumb.css';

export interface BreadcrumbItem {
  label: string;
  path?: string;
  translateKey?: string;
  onClick?: (path: string) => Promise<boolean> | boolean;
  state?: Record<string, unknown>;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
  inline?: boolean;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, inline = false }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const getLabel = (item: BreadcrumbItem): string => {
    if (item.translateKey) {
      return t(item.translateKey);
    }
    return item.label;
  };

  return (
    <nav className={`breadcrumb${inline ? ' breadcrumb-inline' : ''}`} aria-label="Breadcrumb">
      <ol className="breadcrumb-list">
        {items.map((item, index) => {
          const isLast = index === items.length - 1;
          const label = getLabel(item);

          return (
            <li key={index} className="breadcrumb-item">
              {!isLast && item.path ? (
                <>
                  <a
                    href={item.path}
                    className="breadcrumb-link"
                    onClick={async (e) => {
                      e.preventDefault();
                      if (item.onClick) {
                        const canNavigate = await item.onClick(item.path!);
                        if (!canNavigate) return;
                      }
                      if (item.state) {
                        navigate(item.path!, { state: item.state });
                      } else {
                        navigate(item.path!);
                      }
                    }}
                  >
                    {index === 0 && (
                      <span className="material-icons breadcrumb-home-icon">home</span>
                    )}
                    <span>{label}</span>
                  </a>
                  <span className="breadcrumb-separator material-icons">chevron_right</span>
                </>
              ) : (
                <span className="breadcrumb-current" aria-current="page">
                  {label}
                </span>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
